/* eslint-disable react/prefer-stateless-function */
import React, { useState, useEffect } from 'react';
import { useToasts } from 'react-toast-notifications';
import { useParams } from 'react-router-dom';
import { useQuery, useMutation } from 'react-apollo';
import LoadingOverlay from 'react-loading-overlay';
import moment from 'moment';
import OfferDetail from './OfferDetail';
import OfferArtistList from './OfferArtistList';
import OfferCampaignTimeline from './OfferCampaignTimeline';
import MessageList from './OfferMessageList';
import {
  GET_OFFER_DETAIL_QUERY, GET_OFFER_LIST_QUERY, GET_REJECTED_ARTIST_LIST,
  GET_OFFER_PARTICIPATING_ARTIST, GET_PENDING_CONTRACT_ARTIST,
} from '../../../../graphql-client/queries';
import {
  UPDATE_ARTIST_RQUEST, LOADER_MUTATION, INVITE_ARTIST, REMOVE_OFFER,
} from '../../../../graphql-client/mutations';
import {
  loaderStyle, handleGraphqlError, routeConstants, history, NUMERIC_VALUE,
} from '../../../../utils';
import { RequestReject } from '../../../modals';

const query = { limit: NUMERIC_VALUE.FIVE, page: NUMERIC_VALUE.ONE };

function OfferDetailContainer() {
  const { addToast } = useToasts();
  const { offerId } = useParams();
  const [queryObj] = useState({ offerId });
  const [scrollToSegmentId, setScrollToSegmentId] = useState(null);
  const [isRejectModel, setIsRejectModel] = useState(false);
  const [popUpData, setPopUpData] = useState({});
  const [selectedOfferId, setSelectedOfferId] = useState();
  const [showOfferCampaignTimeline, setShowOfferCampaignTimeline] = useState(false);

  const {
    loading, data: offerDetailData, refetch: getUserRefetch,
  } = useQuery(
    GET_OFFER_DETAIL_QUERY, {
      variables: queryObj,
      fetchPolicy: 'network-only',
    },
  );
  const offerDetailResponse = offerDetailData && offerDetailData.offerDetail;

  const [loader] = useMutation(LOADER_MUTATION, {
    variables: { show: true },
  });
  const [removeOffer] = useMutation(REMOVE_OFFER, {
    variables: {},
    refetchQueries: [{
      query: GET_OFFER_LIST_QUERY,
      variables: { page: 1, limit: NUMERIC_VALUE.FIVE },
    }],

    onError(error) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(error), { appearance: 'error' });
    },

    onCompleted(data) {
      loader({ variables: { show: false } });
      addToast(data.removeOffer.message, { appearance: 'success' });
      history.push(routeConstants.ADMIN_OFFER);
    },
  });

  useEffect(() => {
    selectedOfferId && removeOffer({ variables: { offerId: selectedOfferId } });
  }, [selectedOfferId]);

  const deleteOffer = (deleteOffferId) => {
    setSelectedOfferId(deleteOffferId);
  };

  const [updateArtistRequest] = useMutation(UPDATE_ARTIST_RQUEST, {
    variables: {},
    refetchQueries: [{ query: GET_REJECTED_ARTIST_LIST, variables: { offerId, ...query } },
      { query: GET_OFFER_PARTICIPATING_ARTIST, variables: { offerId, ...query } },
      { query: GET_PENDING_CONTRACT_ARTIST, variables: { offerId, ...query } },
    ],

    onError(err) {
      loader({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },
    onCompleted(updateRequestData) {
      loader({ variables: { show: false } });
      addToast(updateRequestData.updateRequest.message, { appearance: 'success' });
      setIsRejectModel(false);
      getUserRefetch(queryObj);
    },
  });

  const [inviteLoader] = useMutation(LOADER_MUTATION, {
    variables: { show: true },
  });

  const [inviteArtist] = useMutation(INVITE_ARTIST, {
    variables: {},
    onError(err) {
      inviteLoader({ variables: { show: false } });
      addToast(handleGraphqlError(err), { appearance: 'error' });
    },

    onCompleted(inviteData) {
      inviteLoader({ variables: { show: false } });
      addToast(inviteData.inviteArtists.message, { appearance: 'success' });
      getUserRefetch(queryObj);
    },
  });

  const onInviteArtist = (artistInviteData) => {
    artistInviteData.offerId = offerId;
    inviteArtist({ variables: artistInviteData });
    inviteLoader({ variables: { show: true } });
  };

  useEffect(() => {
    offerId && getUserRefetch();
  },
  [offerId]);

  useEffect(() => {
    if (offerDetailResponse) {
      const dateValue = moment(offerDetailResponse.data.endDeadline).add(1, 'day').diff(moment(), 'minutes');
      if (dateValue <= NUMERIC_VALUE.ZERO) {
        setShowOfferCampaignTimeline(true);
      }
    }
  },
  [offerDetailResponse && offerDetailResponse.data]);

  function togglePopup(value) {
    setIsRejectModel(!value);
  }

  function openRequestPopup(item) {
    setIsRejectModel(true);
    setPopUpData(item);
  }

  function updateRequestStatus(status, item, rejectReason) {
    if (status === 'reject') {
      togglePopup(isRejectModel);
    }
    updateArtistRequest({
      variables: {
        offerId,
        status,
        artistId: item.userId._id,
        rejectReason,
      },
    });
  }

  return (
    <>
      <LoadingOverlay
        active={loading}
        spinner
        text=""
        className="containerLoader"
        styles={loaderStyle}
      >
        {showOfferCampaignTimeline
          ? (
            <OfferCampaignTimeline
              offerData={offerDetailResponse && offerDetailResponse.data}
              setScrollToSegmentId={setScrollToSegmentId}
            />
          )
          : (
            <OfferArtistList
              details={offerDetailResponse}
              request={offerDetailResponse && offerDetailResponse.request}
              recomended={offerDetailResponse && offerDetailResponse.recomended}
              invitedArtist={offerDetailResponse && offerDetailResponse.invitedArtist}
              viewType={offerDetailResponse
                && offerDetailResponse.data && offerDetailResponse.data.viewType}
              requestModel={(item) => openRequestPopup(item)}
              basePrice={offerDetailResponse && offerDetailResponse.data && offerDetailResponse.data.basePrice}
              categories={offerDetailResponse && offerDetailResponse.data && offerDetailResponse.data.categories}
              updateRequestStatus={(status, item, rejectReason) => updateRequestStatus(status, item, rejectReason)}
              publishAndInviteOffer={onInviteArtist}
              offerId={offerId}
              targetAudience={offerDetailResponse && offerDetailResponse.data && offerDetailResponse.data.targetAudience}
            />
          )}

        {isRejectModel
          && (
            <RequestReject
              isOpen={isRejectModel}
              onClose={() => togglePopup(isRejectModel)}
              popUpData={popUpData}
              updateRequestStatus={(status, item, rejectReason) => updateRequestStatus(status, item, rejectReason)}
            />
          )}
        {
          offerDetailResponse && offerDetailResponse.data
          && (
            <OfferDetail
              offerData={offerDetailResponse && offerDetailResponse.data}
              scrollToSegmentId={scrollToSegmentId}
              onDeleteOfferCallback={deleteOffer}
              updateOfferListing={getUserRefetch}
            />
          )
        }
        <MessageList
          participatingArtist={offerDetailResponse && offerDetailResponse.participatingArtist}
          pendingContract={offerDetailResponse && offerDetailResponse.pendingContract}
          rejectList={offerDetailResponse && offerDetailResponse.reject}
          viewType={offerDetailResponse && offerDetailResponse.viewType}
          offerId={offerId}
          offerMaxDate={offerDetailResponse && offerDetailResponse.data && offerDetailResponse.data.offerMaxDate}
        />
      </LoadingOverlay>
    </>
  );
}

export default OfferDetailContainer;
